import { Material as BABYLON_Material } from '@inter-ikea-betrakta-babylonjs/core/Materials/material.js';
import { GLTFLoader as BABYLON_GLTF2_GLTFLoader } from '@inter-ikea-betrakta-babylonjs/loaders/glTF/2.0/index.js';
import { ViewerMaterial } from '../material/ViewerMaterial.js';
import { LightSystem } from '../light-manager/light-system/LightSystem.js';
const BETRAKTA_BABYLON_EXTENSION_ID = 'BetraktaGLTFLoaderExtension';
// See https://babylonjs.medium.com/extending-the-gltf-loader-in-babylon-js-588e48fb692b for more information
// We use a custom material loader so we can load our material (PBRMaterial) instead of BABYLON_PBRMaterial
export class BetraktaGLTFLoaderExtension {
    /**
     * Register the extension to Babylon
     * @param viewer The viewer currently in use.
     */
    static register_extension(viewer) {
        BABYLON_GLTF2_GLTFLoader.RegisterExtension(BETRAKTA_BABYLON_EXTENSION_ID, (loader) => {
            return new BetraktaGLTFLoaderExtension(loader, viewer);
        });
    }
    /**
     * Unregisters this extension from Babylon
     */
    static unregister_extension() {
        BABYLON_GLTF2_GLTFLoader.UnregisterExtension(BETRAKTA_BABYLON_EXTENSION_ID);
    }
    constructor(loader, viewer) {
        this.name = BETRAKTA_BABYLON_EXTENSION_ID;
        this.enabled = true;
        this._loader = loader;
        this._viewer = viewer;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    createMaterial(context, material, babylon_draw_mode) {
        this._loader.babylonScene._blockEntityCollection = true; // Since we are loading into asset container
        const babylon_material = new ViewerMaterial(material.name || 'material' + material.index, this._loader.babylonScene, this._viewer);
        this._loader.babylonScene._blockEntityCollection = false;
        // TODO: Maybe bring the next one in so we can support both clockwise/counterclockwise content
        // Moved to mesh so user can change materials on gltf meshes: babylonMaterial.sideOrientation = this._babylonScene.useRightHandedSystem ? Material.CounterClockWiseSideOrientation : Material.ClockWiseSideOrientation;
        babylon_material.fillMode = babylon_draw_mode;
        babylon_material.enableSpecularAntiAliasing = true;
        // babylonMaterial.useRadianceOverAlpha = !this._parent.transparencyAsCoverage
        // baylonMaterial.useSpecularOverAlpha = !this._parent.transparencyAsCoverage
        babylon_material.transparencyMode = ViewerMaterial.PBRMATERIAL_OPAQUE;
        babylon_material.metallic = 1;
        babylon_material.roughness = 1;
        babylon_material.maxSimultaneousLights = LightSystem.BABYLON_MATERIAL_MAXIMUM_LIGHT_COUNT;
        // Our own defaults
        babylon_material.sideOrientation = BABYLON_Material.CounterClockWiseSideOrientation; // See above
        babylon_material.useLightmapAsShadowmap = true;
        return babylon_material;
    }
    dispose() {
        // TODO: Should we dispose something?
    }
}
//# sourceMappingURL=BetraktaGLTFLoaderExtension.js.map